export const SECRET_AUCTION_CREATE_PAGE_PATH = '/auction/secret/create'

export const SECRET_AUCTION_LIST_PAGE_PATH = '/auction/secret/list'
